import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-23">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-24">
            <a href="/" className="inline-block mb-6" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/g1ZUhAWEqbLcGxsd7WaXTY/logo.png" alt="TKDScore.com Logo" className="block h-12 w-auto" data-id="element-26" />
            </a>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-27">
              The official distributor of Daedo electronic scoring equipment.
              Equipping elite athletes, schools, and tournaments with the best
              gear in Taekwondo.
            </p>
            <div className="flex space-x-4" data-id="element-28">
              <a href="https://www.facebook.com/TKDScore/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors" aria-label="Facebook" data-id="element-29">
                <FacebookIcon className="w-5 h-5" data-id="element-30" />
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-400 hover:text-white transition-colors" aria-label="Twitter" data-id="element-31">
                <TwitterIcon className="w-5 h-5" data-id="element-32" />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 hover:text-white transition-colors" aria-label="Instagram" data-id="element-33">
                <InstagramIcon className="w-5 h-5" data-id="element-34" />
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors" aria-label="YouTube" data-id="element-35">
                <YoutubeIcon className="w-5 h-5" data-id="element-36" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div data-id="element-37">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-38">
              Shop
            </h4>
            <ul className="space-y-3" data-id="element-39">
              <li data-id="element-40">
                <a href="/shop/daedo-pss-system/" className="hover:text-blue-400 transition-colors" data-id="element-41">
                  Daedo PSS Systems
                </a>
              </li>
              <li data-id="element-42">
                <a href="/shop/daedo-products/" className="hover:text-blue-400 transition-colors" data-id="element-43">
                  Daedo Products
                </a>
              </li>
              <li data-id="element-44">
                <a href="/shop/wacoku-products/" className="hover:text-blue-400 transition-colors" data-id="element-45">
                  Wacoku Products
                </a>
              </li>
              <li data-id="element-46">
                <a href="/Financing.html" className="hover:text-blue-400 transition-colors" data-id="element-47">
                  Financing
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-48">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-49">
              Support
            </h4>
            <ul className="space-y-3" data-id="element-50">
              <li data-id="element-51">
                <a href="https://www.daedosupport.com/portal/en/home" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-52">
                  Contact Us
                </a>
              </li>
              <li data-id="element-53">
                <a href="https://www.daedosupport.com/portal/en/home" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-54">
                  Create Ticket
                </a>
              </li>
              <li data-id="element-55">
                <a href="/download" className="hover:text-blue-400 transition-colors" data-id="element-56">
                  Software Downloads
                </a>
              </li>
              <li data-id="element-57">
                <a href="/thresholds" className="hover:text-blue-400 transition-colors" data-id="element-58">
                  Hit Thresholds
                </a>
              </li>
              <li data-id="element-59">
                <a href="/return-policy" className="hover:text-blue-400 transition-colors" data-id="element-60">
                  Returns & Exchanges
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-61">
          <p className="text-sm text-gray-500 mb-4 md:mb-0" data-id="element-62">
            &copy; {new Date().getFullYear()} TKDScore.com. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}